import { SERVER_URL } from "../../../store/config";
import { logout, refreshTokenIfNeeded } from "../../../store/auth";
import { store } from "../../../store/store";

const { dispatch, getState } = store;

export const loadAutoCompleteUsers = async () => {
  console.log(`[loadAutoCompleteUsers] loading users`);
  const url = `${SERVER_URL}/api/autocomplete/users`;
  return await loadDataUrl(url);
};

export const loadCases = async () => {
  console.log(`[loadCases] loading cases`);
  const url = `${SERVER_URL}/api/cases/`;
  return await loadDataUrl(url);
};

export const loadClips = async (caseId) => {
  console.log(`[loadClips] loading clips: ${caseId}`);
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/`;
  return await loadDataUrl(url);
};

export const loadCase = async (caseId) => {
  console.log(`[loadCase] loading case: ${caseId}`);
  const url = `${SERVER_URL}/api/cases/${caseId}`;
  return await loadDataUrl(url);
};

export const loadChannels = async (caseId, clipId) => {
  console.log(`[loadChannels] loading channels: ${caseId}:${clipId}`);
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/channels`;
  return await loadDataUrl(url);
};

export const loadClip = async (caseId, clipId) => {
  console.log(`[loadClip] loading clip: ${caseId}:${clipId}`);
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}`;
  return await loadDataUrl(url);
};

export const loadCommits = async (caseId, clipId) => {
  console.log(`[loadCommits] loading clip: ${caseId}:${clipId}`);
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/commits`;
  return await loadDataUrl(url);
};

export const loadClipAutocompletes = async (caseId) => {
  console.log(`[loadClipAutocompletes] loading guids: ${caseId}`);
  const url = `${SERVER_URL}/api/autocomplete/cases/${caseId}/clips`;
  return await loadDataUrl(url);
};

export const loadGlimpseOutput = async (caseId, clipId) => {
  console.log(`[loadGlimpseOutput] loading output: ${caseId}:${clipId}`);
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/glimpseOutput`;
  return await loadDataUrl(url);
};

export const loadGlimpseGuids = async (caseId, clipId) => {
  console.log(`[loadGlimpseGUIDs] loading guids: ${caseId}:${clipId}`);
  const url = `${SERVER_URL}/api/player/guid/${clipId}/glimpsed`;
  return await loadDataUrl(url);
};

export const loadMultipleGuids = async (caseId, clipId) => {
  console.log(`[loadMultipleGUIDs] loading guids: ${caseId}:${clipId}`);
  const url = `${SERVER_URL}/api/player/guid/${clipId}/multipleOutputs`;
  return await loadDataUrl(url);
};

export const loadRecordingDevices = async () => {
  console.log(`[loadRecordingDevices] loading recording devices`);
  const url = `${SERVER_URL}/api/autocomplete/recordingdevices`;
  return await loadDataUrl(url);
};

export const loadStoiResults = async (caseId, clipId) => {
  console.log(`[loadStoiResults] loading STOI results: ${caseId}:${clipId}`);
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/intelligibility/results`;
  return await loadDataUrl(url);
};

export const loadUsers = async () => {
  console.log(`[loadUsers] loading users`);
  const url = `${SERVER_URL}/api/users`;
  return await loadDataUrl(url);
};

const loadDataUrl = async (url) => {
  //await dispatch(refreshTokenIfNeeded());
  try {
    const response = await fetch(url, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + getState().auth.accessCode,
      },
    });

    if (response.status === 200) {
      const data = await response.json();
      return data;
    } else if (response.status === 401 || response.status === 403) {
      dispatch(logout());
      return null;
    } else {
      console.error(`[loading] Server Error response code: ${response.status}`);
      return null;
    }
  } catch (e) {
    console.error("[loading] Server exception: ", e);
    return null;
  }
};

export const editorLoadGUID = async (clip, channel) => {
  const { commitId, id: clipId } = clip;
  if (clipId !== 0) {
    console.log(
      `[loadGUID] clipId: ${clipId}  commitId: ${commitId} channel: ${channel}`,
    );
    const url = `${SERVER_URL}/api/player/guid/${clipId}/${channel}`;
    const res = await loadDataUrl(url);
    if (res) {
      return res.value;
    }
  }

  return null;
};

export const filterLoadGUID = async (clip) => {
  const { commitId, id: clipId } = clip;
  if (clipId !== 0) {
    console.log(`[filter loadGUID] clipId: ${clipId}  commitId: ${commitId}`);
    const url = `${SERVER_URL}/api/player/guid/${clipId}/preNoiseFilter`;
    const res = await loadDataUrl(url);
    if (res) {
      return res.value;
    }
  }

  return null;
};

export const queueNormalizeClip = async (caseId, clipId) => {
  console.log(`[queueNormalizeClip] clipId: ${clipId}`);
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/normalizeClip`;
  return await loadDataUrl(url);
};

export const queueSyncClip = async (caseId, clipId, syncFilterRequest) => {
  console.log(`[queueSyncFilter] clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/syncFilter`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(syncFilterRequest),
  });

  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[queueSyncFilter] successful:", simpleResponse);
    return true;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[queueSyncFilter] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const deleteChannel = async (caseId, clipId, channelId) => {
  console.log(`[deleteChannel] clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/channels/${channelId}`;
  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[deleteChannel] successful:", simpleResponse);
    return true;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[deleteChannel] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const restoreChannel = async (caseId, clipId, channelId) => {
  console.log(`[restoreChannel] clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/channels/${channelId}/restore`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[restoreChannel] successful:", simpleResponse);
    return true;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[restoreChannel] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const intelligibilityRequest = async (
  caseId,
  clipId,
  targetClipId,
  requestType,
) => {
  console.log(`[intelligibilityRequest] clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const request = {
    clipId: clipId,
    targetClipId: targetClipId,
    requestType: requestType,
  };
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/intelligibility`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
  });

  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[intelligibilityRequest] successful:", simpleResponse);
    return true;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[intelligibilityRequest] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const acceptSync = async (caseId, clipId) => {
  console.log(`[acceptSync] clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/syncFilter/accept`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[acceptSync] successful:", simpleResponse);
    return true;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[acceptSync] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const getSyncResults = async (caseId, clipId) => {
  console.log(`[getSyncResults] clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/syncFilter/results`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  if (response.status === 200) {
    const syncResults = await response.json();
    // console.log("[getSyncResults] successful:", syncResults);
    return syncResults;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[getSyncResults] Server Returned error code: " + response.status,
    );
  }
  return null;
};

export const rejectSync = async (caseId, clipId) => {
  console.log(`[rejectSync] clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/syncFilter/reject`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[rejectSync] successful:", simpleResponse);
    return true;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[rejectSync] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const clipCloneCommit = async (
  caseId,
  clipId,
  commitId,
  destCaseId,
  newClipName,
) => {
  console.log(
    `[clipCloneCommit] caseId: ${caseId} clipId: ${clipId} commitId: ${commitId}`,
  );
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/commits/${commitId}/clone`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      destCaseId: destCaseId || 0,
      newClipName: newClipName,
    }),
  });

  if (response.status === 201) {
    const clipSnapshot = await response.json();
    console.log("[clipCloneCommit] successful!");
    return clipSnapshot;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      `[clipCloneCommit] Server Error response code: ${response.status}`,
    );
    return null;
  }
};

export const clipClone = async (caseId, clipId, commitId, destCaseId) => {
  // this will clone to an existing case
  if (!destCaseId) destCaseId = caseId;

  return await clipCloneCommit(caseId, clipId, commitId, destCaseId, null);
};

export const clipCloneNewCase = async (caseId, clipId, commitId) => {
  return await clipCloneCommit(caseId, clipId, commitId, 0, null);
};

export const queueSTOIFilter = async (caseId, clipId, formData) => {
  console.log(`[queueSTOIFilter] clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/intelligibility`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ...formData, clipId: clipId, requestType: "STOI" }),
  });
  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[queueSTOIFilter] successful:", simpleResponse);
    return true;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[queueSTOIFilter] Server Returned error code: " + response.status,
    );
  }
};

export const queueAlignmentRequest = async (
  caseId,
  clipId,
  alignmentData,
  requestId,
) => {
  console.log(
    `[queueAlignmentRequest] clipId: ${clipId} requestId: ${requestId}`,
  );
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/alignment`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...alignmentData,
      clipId: clipId,
      requestId: requestId,
    }),
  });
  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[queueAlignmentRequest] successful:", simpleResponse);
    return simpleResponse;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[queueAlignmentRequest] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const queueMergeClipsRequest = async (caseId, clipName, clipIds) => {
  console.log(`[queueMergeClipsRequest] caseId: ${caseId} clipIds: ${clipIds}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/mergeClips`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ clipName, clipIds }),
  });
  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[queueMergeClipsRequest] successful:", simpleResponse);
    return simpleResponse;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[queueMergeClipsRequest] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const queueASIFilterRequest = async (caseId, clipId, data) => {
  console.log(`[queueASIFilterRequest] caseId: ${caseId} clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/asiFilter`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[queueASIFilterRequest] successful:", simpleResponse);
    return simpleResponse;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[queueASIFilterRequest] Server Returned error code: " + response.status,
    );
  }
  return false;
};

export const queueNLMSFilterRequest = async (caseId, clipId, data) => {
  console.log(`[queueNLMSFilterRequest] caseId: ${caseId} clipId: ${clipId}`);
  await dispatch(refreshTokenIfNeeded());
  const url = `${SERVER_URL}/api/cases/${caseId}/clips/${clipId}/nlmsFilter`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getState().auth.accessCode,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (response.status === 200) {
    const simpleResponse = await response.json();
    console.log("[queueNLMSFilterRequest] successful:", simpleResponse);
    return simpleResponse;
  } else if (response.status === 401 || response.status === 403) {
    return dispatch(logout());
  } else {
    console.error(
      "[queueNLMSFilterRequest] Server Returned error code: " + response.status,
    );
  }
  return false;
};
